import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

type Props = {
  children: ReactNode;
  rol?: "admin" | "soporte" | "usuario";
  dueno?: boolean;
};

export default function RequireAuth({ children, rol, dueno }: Props) {
  const user = useAuth((s) => s.user);
  const loading = useAuth((s) => s.loading);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  if (rol === "admin" && user.rol !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (dueno && !user.es_dueno) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
